// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + ({"156":"home-css","157":"installation-css","594":"events-css"}[chunkId] || chunkId) + "-" + {"154":"f644b937a9dcce6e9216","156":"280bd4da200f71670317","157":"d798931456d0307798e6","594":"513ac071bd559449cec0"}[chunkId] + ".css";
};